// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".author-info__name[data-v-98b9bf82]{margin-bottom:10px}.author-info__delimiter[data-v-98b9bf82]{display:inline-block;margin:0 20px;position:relative}@media (max-width:767px){.author-info__delimiter[data-v-98b9bf82]{margin:0 10px}}.author-info__delimiter[data-v-98b9bf82]:after{content:\"\";position:absolute;bottom:-8px;width:2px;background:#817e85;height:29px}@media (max-width:767px){.author-info__delimiter[data-v-98b9bf82]:after{height:20px;bottom:-6px}}", ""]);
// Exports
module.exports = exports;
